module.exports = __webpack_public_path__ + "static/pantai-kenjeran-c4a356e0576ccf837e6cd3d5e42d0ede.png";